/// <reference path="../../../components/models/meevo.model.custom.ts" />
/// <reference path="../../../components/controls/spinner.ts" />

module Meevo.Plugins.InventoryCount {
    import ProductInventoryTypeEnum = Meevo.Model.ProductInventoryTypeEnum;
    import MeevoSpinnerChangeType = Meevo.Components.Controls.MeevoSpinnerChangeType;
    export class BarcodeImportReconcilerModalController {
        public loaded: boolean = false;
        public context: any = {};
        public sortedBy: string = 'variantDisplayName';

        static $inject = [
            "meevo.components.modal.ModalService",
            "options"
        ];

        constructor(
            protected modalService: Meevo.Components.Modal.IModalService,
            public options : any
        ) { 
            if (options.product && options.product.displayName) {
                options.product.displayName = options.product.displayName.replace(/\|/g, ' ');
            }
        }

        $onInit() { 
            console.log('BarcodeImportReconcilerModalController', this.options);
            this.loaded = true;
            this.options.variants.forEach((item) => {
                if (this.showShopSpinner(item) && !this.showRetailSpinner(item)) {
                    item.shopImportCount = item.importCount 
                } else {
                    item.retailImportCount = item.importCount;
                }    
                item.isCounted = true;
                item.variantDisplayName = item.displayName ? `${item.productName} - ${item.displayName.replace('|',' ')}` : item.productName;
                item.scanOrder = this.options.uniqueCodes.indexOf(item.barCode) + 1;

            });
            this.context.closeContext = () => this.closeModal();
        }

        closeModal() {
            this.modalService.hide();
        }

        importScans() {
            console.log('importScans', this.options.variants);
            this.options.variants.forEach(item => {
                if (item.productInventoryType == ProductInventoryTypeEnum.Retail) {
                    item.importCount = item.retailImportCount;
                } else if (item.productInventoryType == ProductInventoryTypeEnum.ShopSupply) {
                    item.importCount = item.shopImportCount;
                }
            });
            
            this.modalService.hideWithResponse(this.options.variants);
        }

        switchSortOrder(type: string) : void {
            this.sortedBy = type;
        }

        currentInventoryTypeChange(val) {
            this.modalService.hideWithResponse(val);
        }

        showRetailSpinner(item) {
            return [Meevo.Model.ProductInventoryTypeEnum.Retail, Meevo.Model.ProductInventoryTypeEnum.RetailOrShopSupply].some(x => x == item.productInventoryType);
        }
       
        showShopSpinner(item) {
            return [Meevo.Model.ProductInventoryTypeEnum.ShopSupply, Meevo.Model.ProductInventoryTypeEnum.RetailOrShopSupply].some(x => x == item.productInventoryType);
        }

        getRetailSpinnerMax(item) {
            return !this.showShopSpinner(item) ? 99999 : item.importCount
        }

        getShopSpinnerMax(item) {
            return !this.showRetailSpinner(item) ? 99999 : item.importCount
        }
        
        onRetailCountChanged(item, type: MeevoSpinnerChangeType) {
            if (type == MeevoSpinnerChangeType.Arrows && this.showShopSpinner(item) && item.retailImportCount <= item.importCount) {
                item.shopImportCount = item.importCount - item.retailImportCount
            }
            item.importCount = item.retailImportCount + item.shopImportCount;
        }

        onShopCountChanged(item, type: MeevoSpinnerChangeType) {
            if (type == MeevoSpinnerChangeType.Arrows && this.showRetailSpinner(item) && item.shopImportCount <= item.importCount) {
                item.retailImportCount = item.importCount - item.shopImportCount
            }
            item.importCount = item.retailImportCount + item.shopImportCount;
        }

    }

    angular.module("meevo.plugins.inventoryCount")
        .controller("meevo.plugins.inventoryCount.BarcodeImportReconcilerModalController", BarcodeImportReconcilerModalController);
}

